import { z } from 'zod';
import { nameSchema } from './common.js';
export const addressSchema = z.string().trim().max(250).nullish();
export const createHouseInputSchema = z.strictObject({
    name: nameSchema,
    address: addressSchema,
});
export const updateHouseInputSchema = createHouseInputSchema
    .partial()
    .refine((value) => Object.keys(value).length > 0, {
    error: 'Provide at least one field to update',
});
//# sourceMappingURL=houses.js.map